export default __webpack_public_path__ + "static/media/29.ef6412fe.png";